export const initialState = {
  currentStep: 1,
  steps: [],
  intro: null,
  totalSteps: 0,
  loading: true,
  error: '',
  audioBlob: null,
  recognizedText: '',
  matchFailed: false,
  submittedText: '',
  showIntro: false,
  showTranslation: {},
  language: 'en',
  optionNumber: 0,
  attemptCount: 0,
  matchedOptionIndex: null,
  assistantSuccess: false, // для помощника Дойча
  endDialog: false, // для концовки диалога
  dialogHistory: [], // для получения истории диалога
  audioTimeEnded: false,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_INITIAL_DATA':
      return { ...state, intro: action.payload.intro, steps: action.payload.steps, totalSteps: action.payload.totalSteps, loading: false, showIntro: !!action.payload.intro?.introAudio, language: action.payload.language || state.language, currentStep: action.payload.currentStep || state.currentStep };
    case 'SET_ERROR':
      return { ...state, error: action.payload, loading: false }; 
    case 'SET_AUDIO_NOT_RECOGNIZED':
      return { ...state, error: action.payload, loading: false };      
    case 'SET_CURRENT_STEP':
      return { ...state, currentStep: action.payload };
    case 'ADD_STEP':
      return { ...state, steps: [...state.steps, action.payload], language: action.payload.language || state.language };
    case 'SET_AUDIO_BLOB':
      return { ...state, audioBlob: action.payload };
    case 'SET_RECOGNIZED_TEXT':
      return { ...state, recognizedText: action.payload };
    case 'SET_MATCH_FAILED':
      return { ...state, matchFailed: action.payload };
    case 'SET_ASSISTANT_SUCCESS':
      return { ...state, assistantSuccess: action.payload };      
    case 'SET_SUBMITTED_TEXT':
      return { ...state, submittedText: action.payload };
    case 'SET_INTRO':
      return { ...state, intro: action.payload };
    case 'SET_SHOW_INTRO':
      return { ...state, showIntro: action.payload };
    case 'TOGGLE_TRANSLATION':
      return { ...state, showTranslation: { ...state.showTranslation, [action.payload]: !state.showTranslation[action.payload] } };
    case 'SET_OPTION_NUMBER':
      return { ...state, optionNumber: action.payload };
    case 'INCREMENT_ATTEMPT':
      return { ...state, attemptCount: state.attemptCount + 1 };
    case 'RESET_ATTEMPT':
      return { ...state, attemptCount: 0 };
    case 'SET_MATCHED_OPTION_INDEX':
      return { ...state, matchedOptionIndex: action.payload };
	case 'SET_END_DIALOG':
      return { ...state, endDialog: action.payload };
	case 'SET_TOTAL_STEP':
      return { ...state, totalSteps: action.payload };	  
    case 'SET_DIALOG_HISTORY':
      return { ...state, dialogHistory: action.payload };	
	case 'SET_AUDIO_TIME_ENDED':
	  return { ...state, audioTimeEnded: action.payload }; 	 	  
    default:
      return state;
  }
};
